import { render, staticRenderFns } from "./RichMenuTarget.vue?vue&type=template&id=5335a5d6&scoped=true&"
import script from "./RichMenuTarget.vue?vue&type=script&lang=js&"
export * from "./RichMenuTarget.vue?vue&type=script&lang=js&"
import style0 from "./RichMenuTarget.vue?vue&type=style&index=0&id=5335a5d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5335a5d6",
  null
  
)

export default component.exports